import { createContext, useContext, useEffect, useState } from "react";
import { findSellerByCode } from "@/lib/sellers";

const STORAGE_KEY = "produlimp_seller_ref";
const SellerRefContext = createContext(null);

export const SellerRefProvider = ({ children }) => {
  const [refCode, setRefCode] = useState(() => localStorage.getItem(STORAGE_KEY) || "");

  // On every URL change, check for ?vendedor=XX and persist if valid
  useEffect(() => {
    const sync = () => {
      const params = new URLSearchParams(window.location.search);
      const v = params.get("vendedor") || params.get("v");
      if (!v) return;
      const seller = findSellerByCode(v);
      if (seller) {
        const code = seller.code;
        setRefCode(code);
        localStorage.setItem(STORAGE_KEY, code);
      }
    };
    sync();
    window.addEventListener("popstate", sync);
    return () => window.removeEventListener("popstate", sync);
  }, []);

  const clearRef = () => {
    localStorage.removeItem(STORAGE_KEY);
    setRefCode("");
  };

  const seller = findSellerByCode(refCode);

  return (
    <SellerRefContext.Provider value={{ refCode, seller, clearRef }}>
      {children}
    </SellerRefContext.Provider>
  );
};

export const useSellerRef = () => useContext(SellerRefContext);
